import React from 'react'
import { FaArrowRight, FaFilePdf } from 'react-icons/fa'
import {Link} from 'gatsby'
import {isUserInRegion} from '../services/auth'
import AccordionLinkFileSingle from './accordion-link-file-single'
import AccordionLinkFile from './accordion-link-file'

const AccordionCommon = ({items, userRegion}) => {

    let filteredItem = items.filter(item => isUserInRegion(userRegion, item.region))
    if(filteredItem && filteredItem.length <=0) return ''

    return (
        <div>
            {
                filteredItem &&
                filteredItem.map((item, i) => {
                    
                    return (
                        <div key={i}>
                            {/* <h5>{item.title}</h5> */}
                            {
                                item.links && item.links.length > 0 &&
                                item.links.map((subOrder, i) => {
                                    
                                    // common
                                    if(subOrder._type === 'link' || subOrder._type === 'fileComponent'){
                                        return <AccordionLinkFileSingle item={subOrder} userRegion={userRegion} key={i} />
                                    }

                                    // common sub-order
                                    if(subOrder._type === 'commonSubOrder' && isUserInRegion(userRegion, subOrder.region)){
                                        return (
                                            <div key={i} /*style={{marginLeft: '1.5rem'}}*/ >
                                                {/* <div>{subOrder.title}</div> */}
                                                {/* <hr className="m-0" /> */}
                                                <AccordionLinkFile items={subOrder.links} userRegion={userRegion} />
                                            </div>
                                        )
                                    }

                                    
                                })
                            }
                        </div>
                    )
                })
            }
        </div>
    )
}

export default AccordionCommon